import React, { useState } from 'react';

import { handleCopy } from '../../../helpers/handleCopy';
import { openLinkInNewTab } from '../../../helpers/openLinkInNewTab';

import CopyAlert from '../../../design-system/CopyAlert/CopyAlert';
import { Button } from '../../../design-system';
import { FileCopyLineIcon } from '../../../design-system/Icons';

const PromptTabActionButtons = ({
    isEditing,
    prompt,
    promptId,
    onSave,
    onCancel,
    saveButtonState,
    cancelButtonState,
}) => {
    const [copyAlert, setCopyAlert] = useState(null);

    const onCopy = () => handleCopy(prompt, setCopyAlert, 'Prompt successfully copied!');
    const onStartChat = () => openLinkInNewTab(`/assistant?tab=chats&prompt=${promptId}`);

    return (
        <div
            className="fixed bottom-3 right-3 min-[1380px]:bottom-[18px] min-[1380px]:right-4 3xl:bottom-5 3xl:right-8 p-1 flex items-center gap-2.5 rounded-2"
            style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', backdropFilter: 'blur(8px)' }}
        >
            {!isEditing && (
                <>
                    <Button
                        size="sm"
                        type="link"
                        text="Copy"
                        leadingIcon={FileCopyLineIcon}
                        onClick={onCopy}
                    />
                    <Button size="sm" type="secondary" text="Start Chat" onClick={onStartChat} />
                </>
            )}

            {isEditing && (
                <>
                    <Button
                        size="sm"
                        type="link"
                        text="Cancel"
                        state={cancelButtonState}
                        onClick={onCancel}
                    />
                    <Button
                        size="sm"
                        type="secondary"
                        text="Save"
                        state={saveButtonState}
                        onClick={onSave}
                    />
                </>
            )}

            <CopyAlert copyAlert={copyAlert} setCopyAlert={setCopyAlert} />
        </div>
    );
};

export default PromptTabActionButtons;
